<template>
  <div class="electrify">
    <div class="nav">
      <el-form :model="form" label-width="80px" :inline="true"  class="demo-form-inline flex1">
        <el-form-item label="港口名称:">
          <el-input v-model="form.portName" size="mini" placeholder="请输入港口名称"></el-input>
        </el-form-item>
        <el-form-item label="作业编号:">
          <el-input v-model="form.workNumber" size="mini" placeholder="请输入作业编号"></el-input>
        </el-form-item>
        <el-form-item label="作业类型:">
          <el-input v-model="form.workType" size="mini" placeholder="请选择作业类型"></el-input>
        </el-form-item>
<!--        <el-form-item label="批次号:">-->
<!--          <el-input v-model="form.batch" size="mini" placeholder="请输入批次号"></el-input>-->
<!--        </el-form-item>-->
<!--        <el-form-item label="底盘号:">-->
<!--          <el-input v-model="form.chassis" size="mini" placeholder="请输入底盘号"></el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="作业时间:">
          <el-date-picker v-model="form.workTime[0]" size="mini" style="width:150px" value-format="yyyy-MM-dd HH:mm:ss" @change="dateChange" type="datetime" placeholder="开始日期"/>
          <span style="display:inline-block;width:15px;text-align:center;font-size:18px">-</span>
          <el-date-picker v-model="form.workTime[1]" size="mini" style="width:150px" value-format="yyyy-MM-dd HH:mm:ss" @change="dateChange" type="datetime" placeholder="结束日期"/>
        </el-form-item>

        <el-form-item label="是否生成对账单:" label-width="130px">
          <el-select v-model="form.whetherBill" filterable size="mini" placeholder="请选择是否生成对账单">
            <el-option label="全部" value=""></el-option>
            <el-option label="是" value="1"></el-option>
            <el-option label="否" value="0"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item>
          <el-button size="small" class="searchBtn" @click="searchBtn">查询</el-button>
          <el-button size="small" class="resetBtn" @click="resetBtn">重置</el-button>
          <el-button size="small" type="primary" @click="addBtn">生成对账单</el-button>
          <el-button size="small" type="primary" @click="addResetBtn">刷新结算</el-button>
        </el-form-item>

      </el-form>
    </div>
    <el-row>
      <el-col :span="24" style="text-align: end;" class="exportButton">
        <el-popover
          placement="bottom"
          width="160"
          trigger="hover"
          v-model="visible">
          <p>选择赛选条件</p>
          <div >
            <el-checkbox-group v-model="checkList" >
              <el-checkbox label="运单编号"></el-checkbox>
              <el-checkbox label="批次号"></el-checkbox>
              <el-checkbox label="底盘号"></el-checkbox>
              <el-checkbox label="委托商" ></el-checkbox>
              <el-checkbox label="计划时间" ></el-checkbox>
              <el-checkbox label="交车时间" ></el-checkbox>
              <el-checkbox label="运输条款" ></el-checkbox>
            </el-checkbox-group>
          </div>
          <div style="text-align: right; margin: 0">
            <el-button size="mini" type="text" @click="()=>{ this.visible=false;this.checkList=[]}">取消</el-button>
            <el-button type="primary" size="mini" @click="importClick">确定</el-button>
          </div>
          <span slot="reference">导入生成对账单</span >
        </el-popover>
        <!--        <span @click="importClick">导入生成对账单</span>-->
        <span>导出数据</span>
      </el-col>
    </el-row>
    <div class="content">
      <div class="tableContainer">
        <el-table
          v-loading="tableLoad"
          :data="TableDatas"
          style="width: 100%"
          border
          stripe
          tooltip-effect="dark"
          ref="multipleTable"
          @select="handleCurrentChange"
          @select-all="handleCurrentChange"
           :header-cell-style="{color:'#3B3B3B','font-size':'13px','height':'48px',background:'#E8E8E8'}"
          :cell-style="{height:'42px',}"
          :row-key="(row)=>{return row.id}"
          :reserve-selection="true">
          <el-table-column type="selection" align="center" width="70px" :reserve-selection="true" :selectable="(row,index)=>{return row.isReconciliation !== 1}"/>
          <el-table-column prop="portName" label="港口名称" align="center" width="120" show-overflow-tooltip/>
          <el-table-column prop="workNumber" label="作业编号" align="center" width="120" show-overflow-tooltip/>
          <el-table-column prop="workType" label="作业类型" align="center">
            <template slot-scope="scope">{{scope.row.workType |workTypeFormat}}</template>
          </el-table-column>
          <el-table-column prop="sss" label="台账月" align="center" width="100" show-overflow-tooltip>
            <template slot-scope="scope">
              <el-input size="mini" v-model="scope.row.sss" :disabled="scope.row.isReconciliation ===1 ?true : false"></el-input>
            </template>
          </el-table-column>
          <el-table-column prop="workDate" label="作业时间" align="center" width="120" show-overflow-tooltip>
            <template slot-scope="scope">{{scope.row.workDate |formatTime}}</template>
          </el-table-column>
          <el-table-column prop="workTotal" label="作业数量" align="center" >
            <template slot-scope="scope">
              <i :class="scope.row.isTableExpandShow ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
                 style="margin-right: 20px;cursor: pointer" @click="tableShow(scope.$index,scope.row)">
              </i>
              {{scope.row.workTotal}}
            </template>
          </el-table-column>
          <el-table-column prop="operationTotal" label="加油/搭电量" align="center"/>
          <el-table-column prop="taxRate" label="税率(%)" align="center"/>
          <el-table-column prop="taxPrice" label="含税费用" align="center"/>
          <el-table-column prop="price" label="不含税费用" align="center"/>
          <el-table-column prop="isReconciliation" label="生成对账单" align="center" width="100%">
            <template slot-scope="scope">{{scope.row.isReconciliation|isGenerateBillFormat}}</template>
          </el-table-column>
          <el-table-column type="expand" width="1">
            <template slot-scope="scope">
              <el-table v-show="scope.row.isTableExpandShow" :data="scope.row.children" v-loading="childrenLoading"
                        :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}" stripe border style="margin: 0;padding: 0;width: 50%">
                <el-table-column prop="batchNumber" label="批次号"  align="center"></el-table-column>
                <el-table-column prop="chassisNumber" label="底盘号"  align="center"></el-table-column>
                <el-table-column prop="brand" label="品牌"  align="center"></el-table-column>
                <el-table-column prop="model" label="型号"  align="center"></el-table-column>
              </el-table>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="paginationContainer">
        <el-pagination
          background
          :page-sizes="[10, 20, 30, 40]"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
          @size-change="contractSizeChange"
          @current-change="contractCurrentChange"
          :current-page.sync="form.page"
          :page-size="form.rows"
        />
      </div>
    </div>
    <!-- :width="activeName ==='cost'? '1250px':'750px'" -->
    <el-dialog :title=" importShow ?'导入生成对账单':'生成对账单'" :visible.sync="addflag" width="750"
               center @close="dialogClose">

      <div class="importBill">
        <el-tabs v-model="activeName" >
          <el-tab-pane  name="information">
            <template slot="label">
              基础信息
            </template>
            <div class="information">
              <el-form :model="informationData" label-width="150px" label-position="right" :rules="rules" ref="ruleForm" class="demo-ruleForm">
                <el-form-item label="付款公司:" prop="">
                {{informationData.supplier}}
                </el-form-item>
                <el-form-item label="标题:" prop="title">
                  <el-input size="mini" placeholder="请输入对账单标题"  v-model="informationData.title"></el-input>
                </el-form-item>
                <el-form-item label="收取费用:" prop="Deductible" style="margin-bottom: 17px;">
                  <el-input size="mini" v-model="informationData.Deductible" >
                    <i slot="suffix" class="input-right" style="">元</i>
                  </el-input>
                </el-form-item>

                <el-form-item label="备注:">
                  <el-input size="mini" placeholder="请输入备注" :autosize="{ minRows: 5, maxRows: 10}"
                            v-model="informationData.remark"
                            style="width:56% "
                            type="textarea"></el-input>
                </el-form-item>
                <el-form-item style="margin-left: 80px">
                  <el-button type="primary" size="mini" @click="accountAdd">确认</el-button>
                  <el-button type="info" size="mini">取消</el-button>
                </el-form-item>
              </el-form>
            </div>
          </el-tab-pane>
          <el-tab-pane  name="cost">
            <template slot="label">
              结算费用

            </template>
            <div class="cost">
              <div class="operation">
                <div class="total" style="margin-left: 35px">
                  <el-row style="margin-bottom: 10px">
                    <el-col :span="9" style="font-size: 14px;color: #606266;font-weight: 700;">
                      合计含税费用:{{sumContract}}
                    </el-col>
                    <el-col :span="9" style="font-size: 14px;color: #606266;font-weight: 700;">
                      合计不含税费用:{{sumNotIncluded}}
                    </el-col>

                  </el-row>
                </div>
                <div class="operationTitle" v-if="importShow">
                  <div class="line"/>
                  <span>已选择运单</span>
                </div>
                <div class="operationTable">
                  <el-table
                    v-loading="checkLoad"
                    :data="checkTableData"
                    ref="checkTable"
                    style="width: 100%"
                    border
                    :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
                    :row-class-name="tableRowClassName"
                  >

                    <el-table-column prop="portName" label="港口名称" align="center"/>
                    <el-table-column prop="workNumber" label="作业编号" align="center"/>
                    <el-table-column prop="workType" label="作业类型" align="center">
                      <template slot-scope="scope">{{scope.row.workType |workTypeFormat}}</template>
                    </el-table-column>
                    <el-table-column prop="workDate" label="作业时间" align="center">
                      <template slot-scope="scope">{{scope.row.workDate |formatTime}}</template>
                    </el-table-column>
                    <el-table-column prop="workTotal" label="作业数量" align="center" >
                      <template slot-scope="scope">
                        <i
                          :class="scope.row.isTableExpandWorkShow ? 'el-icon-arrow-down' : 'el-icon-arrow-right'"
                          style="cursor: pointer" @click="tableShowWork(scope.$index,scope.row)"></i>{{scope.row.workTotal}}
                      </template>
                    </el-table-column>
                    <el-table-column prop="operationTotal" label="加油/搭电量" align="center"/>
                    <el-table-column prop="taxRate" label="税率(%)" align="center"/>
                    <el-table-column prop="taxPrice" label="含税费用" align="center"/>
                    <el-table-column prop="price" label="不含税费用" align="center"/>
                    <el-table-column  label="操作" align="center">
                      <template slot-scope="scope">
                        <div class="iconError">
                          <!-- 1 为运单费用-->
                          <i class="el-icon-error" @click="deleteClick(scope.$index,1)"></i>
                        </div>
                      </template>
                    </el-table-column>
                    <el-table-column type="expand"   width="1">
                      <template slot-scope="scope" >

                        <el-table v-show="scope.row.isTableExpandWorkShow" :data="scope.row.children"
                                  :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}" stripe border style="margin: 0;padding: 0;width: 50%">
                          <el-table-column prop="batchNumber" label="批次号"  align="center"></el-table-column>
                          <el-table-column prop="chassisNumber" label="底盘号"  align="center"></el-table-column>
                          <el-table-column prop="brand" label="品牌"  align="center"></el-table-column>
                          <el-table-column prop="model" label="型号"  align="center"></el-table-column>
                        </el-table>
                      </template>

                    </el-table-column>
                  </el-table>

                </div>
                <div class="operationTitle" v-if="importShow">
                  <div class="line"/>
                  <span>未选择运单</span>
                </div>
                <div class="operationTable" v-if="importShow">
                  <el-table
                    v-loading="checkLoad"
                    :data="notTableData"
                    style="width: 80%"
                    border
                    :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"
                  >
                    <el-table-column label="序号" align="center" width="50px">
                      <div slot-scope="scope">{{scope.$index+1}}</div>
                    </el-table-column>
                    <el-table-column prop="chassisNumber" label="运单编号" align="center"/>
                    <el-table-column prop="batchNumber" label="批次号" align="center"/>
                    <el-table-column prop="chassis" label="底盘号" align="center"/>
                    <el-table-column prop="brand" label="品牌" align="center"/>
                    <el-table-column prop="model" label="型号" align="center"/>
                    <el-table-column prop="transport" label="费用类型" align="center"/>
                    <el-table-column prop="taxRate" label="税率(%)" align="center"/>
                    <el-table-column prop="included" label="含税费用" align="center" />
                    <el-table-column prop="afterTax" label="税后费用" align="center" />
                    <el-table-column prop="remark" label="说明" align="center" />
                    <el-table-column  label="操作" align="center">
                      <template slot-scope="scope">
                        <el-button size="mini" type="primary" @click="addWaybill(scope.$index)">添加</el-button>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
              </div>

            </div>
          </el-tab-pane>
          <!--        其他费用-->
<!--          <el-tab-pane  name="otherCost">-->
<!--            <template slot="label">-->
<!--              其他费用-->

<!--            </template>-->
<!--            <div class="otherCost">-->
<!--              <div class="total" style="margin-left: 35px">-->
<!--                <el-row style="margin-bottom: 10px">-->
<!--                  <el-col :span="7" style="font-size: 14px;color: #606266;font-weight: 700;">合计含税费用:{{otherIncluded}}</el-col>-->
<!--                  <el-col :span="7" style="font-size: 14px;color: #606266;font-weight: 700;">合计不含税费用:{{otherNotIncluded}}</el-col>-->
<!--                </el-row>-->
<!--                <div class="otherAdd" style="margin-bottom: 10px" @click="otherAddClick">添加</div>-->
<!--              </div>-->
<!--              <el-table-->
<!--                v-loading="checkLoad"-->
<!--                :data="otherTableData"-->
<!--                style="width: 100%"-->
<!--                border-->
<!--                :header-cell-style="{background:'#E8E8E8',color:'#3B3B3B'}"-->
<!--                :row-class-name="tableRowClassName"-->
<!--              >-->
<!--                <el-table-column label="序号" align="center" width="50px">-->
<!--                  <div slot-scope="scope">{{scope.$index+1}}</div>-->
<!--                </el-table-column>-->
<!--                <el-table-column prop="Waybill" label="费用编号" align="center"/>-->
<!--                <el-table-column prop="Waybill" label="费用类型" align="center"/>-->
<!--                <el-table-column prop="Waybill" label="费用说明" align="center" />-->
<!--                <el-table-column prop="Waybill" label="税率(%)" align="center"/>-->
<!--                <el-table-column prop="included" label="含税合同价" align="center" />-->
<!--                <el-table-column prop="notIncluded" label="不含税合同价" align="center" />-->

<!--                <el-table-column  label="操作" align="center">-->
<!--                  <template slot-scope="scope">-->
<!--                    <div class="iconError">-->
<!--                      &lt;!&ndash;   2 为其他费用删除&ndash;&gt;-->
<!--                      <i class="el-icon-error" @click="deleteClick(scope.$index,2)"></i>-->
<!--                    </div>-->
<!--                  </template>-->
<!--                </el-table-column>-->
<!--              </el-table>-->

<!--            </div>-->
<!--          </el-tab-pane>-->
          <slot name="elTabPane"></slot>
        </el-tabs>

      </div>

    </el-dialog>
<!--    <el-dialog title="添加其他费用" :visible.sync="otherAddFlag" append-to-body width="750px">-->
<!--      <otherAdd @otherDataCelect="otherData" ref="otherAdds" :otherDateProps="JSON.parse(JSON.stringify(otherTableData))"></otherAdd>-->
<!--    </el-dialog>-->

  </div>
</template>

<script>
  import divBorder from "@/components/divBorder";
  import steps from "@/components/steps";
  import {
    deductionInvoicingCostGetAllByCompanyId,
    refuelingpowerList,
    refuelingpowerVehicleAllListById,
    customerAdd
  } from "@/service/getData"
  import {formatTime} from "@/config/mUtils";
  export default {
    components: {
    },

    data() {
      return {
        form:{
          portName:"",//港口名称
          workNumber:"",//作业编号
          workType:"",//作业类型
          workTime:['',''],//作业时间
          whetherBill:'',//是否生成账单
          page:1,
          rows:10,
        },
        total:0,
        tableLoad:false,
        childrenLoading:false,
        TableDatas:[],
        checkList:['运单编号','批次号','运输条款'],//导入生成账单 选择数据
        visible:false,//导入生成账单 筛选条件显示

        importShow:false,
        otherAddFlag:false,//其他费用添加
        activeName:'information',//标签页
        otherAddFlag:false,
        isDisabled:false,//是否启用合同价
        consignorId:'',//公司id
        informationData:{
          Deductible:'',//抵扣费用
          title:'',
          remark:'',
        },
        checkLoad:false,
        notTableData:[],
        otherTableData:[],//其他费用
        checkTableData:[],
        otherIncluded:0,//其他费用合计
        otherNotIncluded:0,//其他费用合计
        sumContract:0,//作业费用合计
        sumNotIncluded:0,
        stepData:[
          {title:'张三发起',time:'2021-9-30 14:09:23',state:'',remark:''},
          {title:'财务部 张三通过',time:'2021-9-30 14:09:23',state:'success',remark:'原因xxxxxx'},
          {title:'技术部 李四拒绝',time:'2021-9-30 14:09:23',state:'failure',remark:'原因xxxxxx'},
          {title:'张三重新发起',time:'2021-9-30 14:09:23',state:'',remark:''},
        ],

        addflag:false,
        rules:{
          plan:{required: true, message: ' ', trigger: 'blur'},
          name:[
            { required: true, message: '请输入业务名称', trigger: 'blur' },
            { min: 3, max: 9, message: '长度在 3 到 9 个字符', trigger: 'blur' }
          ],
          content:{required: true, message: '请输入评审需求', trigger: 'blur'},
          type: { required: true, message: '请选择评审类型', trigger: 'blur' },
          img:{ required: true, message: '请选择合同照片', trigger: 'blur' },
          Deductible:{required: true, message: '请输入收取费用', trigger: 'blur'},
          title:{required: true, message: '请输入标题', trigger: 'blur'},
        }

      };

    },
    computed:{
      stepState(){
        return function(state){
          switch(state) {
            case '':
              return 'wait'
            case 'success':
              return 'success'
            case 'failure':
              return 'error'
          }
        };
      },
    },
    watch:{
      checkTableData(val){
        console.log(val)
        this.sumContract = this.calculation(val,'taxPrice')

        this.sumNotIncluded = this.calculation(val,'price')

        //合计不/含税费用
        this.sumCost()
        //  判断 不/含税合同价是否为空  value  value2其他费用
        this.decideContract(val,this.otherTableData)

      },
      otherTableData(val){
        this.otherIncluded=this.calculation(val,'included')
        this.otherNotIncluded =this.calculation(val,'notIncluded')
        //合计不/含税费用
        this.sumCost()

        this.decideContract(this.checkTableData,val,)

      }
    },
    filters:{
      isGenerateBillFormat(value){
        switch (value) {
          case 0 :
            return '否'
          case 1 :
            return '是'
        }
      },
      formatTime(val){
        if(val){
          return formatTime(val, "yyyy-mm-dd")
        }else {
          return ''
        }


      },
      workTypeFormat(value){
        switch (value) {
          case 1:
            return '加油';
          case 2:
            return '搭电';
        }
      },
    },
    mounted(){
      this._refuelingpowerList()
    },
    methods: {
      init(){

      },
      //分页查询
      async _refuelingpowerList(){
        let {portName,workNumber,workType,workTime,whetherBill} = this.form
        let obj={
          ...this.form,
          workDate:workTime ? workTime[0]:'',
          workDateEnd:workTime ? workTime[1]:'',
          isReconciliation:whetherBill
        }
        if (!workTime) {
          delete obj.workDate;
          delete obj.workDateEnd;
        }
        this.tableLoad = true
        let res =await refuelingpowerList(obj)
        this.tableLoad = false
        if (res.status !==0) return this.$message.error(res.message)
        this.total = res.data.total
        this.TableDatas = res.data.records
      },
      //子分页查询
      async _refuelingpowerVehicleAllListById(id){
        this.childrenLoading = true
        let res = await refuelingpowerVehicleAllListById({id:id})
        this.childrenLoading = false
        if (res.status !==0) return this.$message.error(res.message)
        return  res.data
      },
      compareDate(d1,d2) {
        return ((new Date(d1.replace(/-/g,"\/"))) > (new Date(d2.replace(/-/g,"\/"))));
      },
      // 结束时间
      dateChange(val) {
        if(this.form.workTime[1]&&this.form.workTime[0]&&this.compareDate(this.form.workTime[0],this.form.workTime[1])) {
          if(val == this.form.workTime[1]) this.form.workTime[1] = '';
          if(val == this.form.workTime[0]) this.form.workTime[0] = '';
          this.$forceUpdate();
          return this.$message.warning("结束日期必须大于开始日期！");
        }
      },

      //合计不/含税费用
      sumCost(){
        this.informationData.sumIncluded = this.sumContract +this.otherIncluded
        this.informationData.sumNotIncluded = this.sumNotIncluded +this.otherNotIncluded
      },
      async _customerAdd(){
        let {supplier,Deductible,remark,title} = this.informationData
        let settIds = ''
        this.checkTableData.forEach((item,index)=>{
          //最后一个不加逗号
          settIds+=index ===this.checkTableData.length-1 ? item.id :item.id+","
        })
        let otherCostIds = ''
        this.otherTableData.forEach((item,index)=>{
          //最后一个不加逗号
          otherCostIds+=index ===this.otherTableData.length-1 ? item.id :item.id+","
        })
        let obj={
          companyId:this.consignorId,
          companyNameOld:this.oldSupplier,
          companyNameNew:supplier,
          amount:Number(Deductible),
          title:title,
          remark:remark,
          type:3,//委托商未知结算
          settIds:this.checkTableData.length>0?settIds:'',
          otherCostIds:this.otherTableData.length>0 ? otherCostIds:''
        }
        let res =await customerAdd(obj)
        if (res.status !==0) return this.$message.error(res.message)
        this.$message.success(res.message)
        await this._refuelingpowerList()
        this.dialogClose()
      },
      // 生成对账单按钮
      addBtn(){
        if(this.checkTableData.length <= 0) {
          return this.$message.warning("请至少选择一条结算数据！")
        }
        let flg = false;
        if(this.checkTableData.length > 0) {
          let temp = this.checkTableData[0].consignorId;
          this.checkTableData.forEach(item => {
            if(item.consignorId != temp){
              return flg = true;
            }
          })
        }
        if(flg) {
          return this.$message.warning("只能选择同一家委托商数据！");
        }
        this.addflag = true
        this.importShow =false
        this.informationData.supplier = this.TableDatas[0].portName
      },
      // 刷新结算按钮
      addResetBtn(){
        console.log('刷新结算');
      },
      searchBtn(){
        this.form.page = 1;
        this._refuelingpowerList()
      },
      resetBtn(){
        for (const argumentsKey in this.form) {
          this.form[argumentsKey] = ""
        }
        this.form.workTime = ['',''];
        this.form.page = 1
        this.form.rows = 10

      },
      contractSizeChange(row){
        this.form.rows=row;
        this._refuelingpowerList()
      },
      contractCurrentChange(page){
        this.form.page=page;
        this._refuelingpowerList()
      },

      getSummaries(param) {
        const { columns, data } = param;
        const sums = [];
        columns.forEach((column, index)=>{
          if (index===0){
            sums[index] = "合计";
          }else if (index >= 11){
            const values = data.map((item) => Number(item[column.property]));
            if (!values.every((value) => isNaN(value))) {
              sums[index] = values.reduce((prev, curr) => {
                return prev+curr;
              },0)


            }
            console.log(column)
          }
        })
        return sums
      },
      // deleteClick(index){
      //   this.checkTableData2.splice(index,1)
      // },
      // 导入
      importClick(index,row){
        if (this.checkList.length <3) return this.$message.warning('最少选择三个条件')
        this.visible=false
        this.importShow = true
        this.addflag = true
      },
      // 多选事件触发
      handleCurrentChange(val){
        this.checkTableData =val

        let Waybill = ''
        let array =val.filter((item,index)=>{
          if(index===0) Waybill =item.portName
          return Waybill !==item.portName
        })
        // 筛选  供应商相同数据
        this.checkTableData =val.filter(item=>{
          return Waybill===item.portName
        })
        array.forEach((value)=>{
          // 只有使用表格原数据，才会生效   从表格原数据中赛选
          this.$message.warning('只能选择相同的供应商')
          this.$refs.multipleTable.toggleRowSelection(this.TableDatas.find((item)=>{
            return value.id ===item.id
          }),false);
        })

        // this.$refs.accountState.calculation()
      },
      handleCurrentChangeAll(val){
        this.checkTableData =val
        console.log(val)
        console.log( this.checkTableData)

        // this.$refs.accountState.calculation()
      },
      tableRowClassName({row}) {
        if (this.sumContract !==this.sumNotIncluded && this.importShow) return 'ui-warning-row';
        else return '';
      },

      selectChange(){//勾选
        //先清空选择
        this.$refs.multipleTable.clearSelection()
        this.$nextTick(()=>{
          this.checkTableData.forEach(row => {
            // 只有使用表格原数据，才会生效   从表格原数据中赛选
            this.$refs.multipleTable.toggleRowSelection(this.TableDatas.find((item)=>{
              return row.id ===item.id
            }));
          });
        })
      },
      dialogClose(){
        this.activeName='information'
        this.addflag = false//关闭窗口
      //清空
      for (let informationDataKey in this.informationData) {
        this.informationData[informationDataKey] = ''

      }
      //清除提示
      this.$refs.ruleForm.resetFields();
      // this.checkTableData =[]
      },
      calculation(table,zi){
        let sum=0
        table.forEach((item,index)=>{
          sum += Number(item[zi])
          console.log(sum)
        })
        return sum
      },
      deleteClick(index,flag){
        if (flag ===1){
          let array =this.checkTableData.splice(index,1)

          array.forEach((item)=>{
            this.notTableData.push(item)
          })
          console.log(this.notTableData)
          this.selectChange()
        }else {
          this.otherTableData.splice(index,1)
          this.$refs.otherAdds.toggleSelection()

        }

      },
      otherAddClick(){
      this.consignorId = this.checkTableData.length > 0 ?this.checkTableData[0].consignorId:''
        this.otherAddFlag =true
        this.$nextTick(()=>{
        this.$refs.otherAdds._othercostGetAllByCompanyId()
      })
      },
      addWaybill(index){
        let a =this.notTableData.splice(index,1)
        this.checkTableData.push(a[0])
        this.selectChange()
      },
      //  判断 不/含税合同价是否为空  value  value2其他费用
      decideContract(value,value2){
        let flag=true
        value.forEach((item,index)=>{
          if (item.Contract===null||item.sumNotIncluded===null) {
            //是否禁用选项
            this.isDisabled = true
            flag=false
            console.log(this.isDisabled)
            this.informationData.Settlement = 2
            throw new Error("不/含税合同价为空");
          }else {
            flag=true
          }
        })
        value2.forEach((item)=>{
          if (item.included===null||item.notIncluded===null){
            //是否禁用选项
            this.isDisabled = true
            flag=false
            console.log(this.isDisabled)
            this.informationData.Settlement = 2
            //终止foreach 并且不执行后面的代码
            throw new Error("不/含税合同价为空");
          }else {
            flag=true
          }
        })

        if (flag){
          this.isDisabled = false
        }
      },
      async tableShow(index,row){

        row.isTableExpandShow = !row.isTableExpandShow
        if(row.isTableExpandShow) row.children =await this._refuelingpowerVehicleAllListById(row.id)

        this.$refs.multipleTable.toggleRowExpansion(row,row.isTableExpandShow)
      },
      async tableShowWork(index,row){
        row.isTableExpandWorkShow = !row.isTableExpandWorkShow
        if(row.isTableExpandWorkShow) row.children =await this._refuelingpowerVehicleAllListById(row.id)
        // if(row.isTableExpandWorkShow) row.children =[
        //   {
        //     batchNumber:'DKDJe9484948',
        //     chassisNumber:'2342323',
        //     brand:'大众品牌',
        //     model:"A0105",
        //     id:'9343254746'
        //   }
        // ]
        this.$refs.checkTable.toggleRowExpansion(this.checkTableData[index],row.isTableExpandWorkShow)
      },
      //生产对账点 确认
      accountAdd(){
      if (this.checkTableData.length<=0) return this.$message.warning('作业费用不能为空')
        this.$refs.ruleForm.validate((valid) => {
          if (valid){
            this._customerAdd()
          }else {

          }
        })
      },
    },
  };
</script>



<style lang="scss" scoped>
  .electrify{
    width:100%;
    padding:20px 15px 0 25px;
    height: 100%;
    .exportButton{
      span{
        color: rgba(51, 136, 255, 1);
        text-decoration: underline;
        margin-right: 10px;
        font-size: 16px;
        text-decoration: underline;
        &:hover{
          cursor: pointer;
        }
      }
    }
    ::v-deep .el-table__header .has-gutter tr .el-table-column--selection .cell .el-checkbox::after{
      color: #606266;
      content: "全选";
      font-size: 12px;
      margin-left: 2px;

    }
    ::v-deep.nav{
      width:100%;
      display: flex;
      align-items: center;
      overflow: hidden;
      .flex1{
        flex: 1;
      }
      .el-input{
        width: 150px;
      }
      .el-select{
        width: 150px;
      }
      .el-form-item{
        margin-bottom: 5px;
      }
      label.el-form-item__label {
        font-weight: 500;
        color: #101010;
      }
    }
    .content{
      ::v-deep{
        .el-table__expanded-cell{
          padding: 0;
          text-align: end;
          .el-table{
            left: 50%;
          }
        }
        .el-table__expand-icon >i {
          display: none;
        }
        .el-table th>.cell{
          font-weight: 700!important;
        }
        .el-table .cell,.el-table td{
          padding: 0;
        }
      }
    }
    ::v-deep .importBill{
      width: 100%;
      padding: 10px 16px 20px 20px;
      .line{
        width: 12px;
        height: 32px;
        background-color: rgba(51, 84, 131, 100);
        margin-right: 10px;
      }
      .line +span{
        font-size: 16px;
        color: rgba(51, 84, 131, 100);
        font-weight: 600;
      }
      .el-table td, .el-table th{
        padding:0;
      }
      .el-tabs__item.is-active{
        color: #335483
      }
      .el-tabs__item{
        font-weight: bold!important;
      }
      cell{
        font-size: 10px;
        padding:0;
      }
      .el-table .ui-warning-row {
        background-color: #fef0f0!important;
      }
      .el-table--enable-row-hover .el-table__body tr.ui-warning-row:hover>td{
        background-color: #fef0f0!important;
      }
      .el-table .ui-warning-row .cell{
        color: red;
      }
      .information{
        /*width: 83%;*/
        .el-form-item__label{
          font-weight: 700;
        }
        .el-input{
          width: 56%;
        }
        .el-form-item{
          margin-bottom: 9px;
        }
        .icon{
          color: red;
          font-size: 20px;
          margin-left: 20px;
          span{
            font-size: 15px;
          }
        }

      }
      .cost {
        .iconError {
          font-size: 20px;

          i:hover {
            color: #00e1ff;
          }
        }
        .el-table__expanded-cell{
          padding: 0;
          text-align: end;
          .el-table{
            left: 50%;
          }
        }
        .el-table__expand-icon >i {
          display: none;
        }

      }
      .operation{
        display: flex;
        flex-direction: column;
        margin-top: 20px;
        &Title{
          display:flex;
          align-items:flex-end;
          p{
            font-weight: 700;
            font-size: 14px;
            color: rgba(51, 136, 255, 1);
            margin-left: 10px;
          }
        }
        &Table{
          width:100%;
          margin-top: 10px;
          padding-right: 20px;
          .el-button--mini{
            padding: 4px 4px;
          }
        }
      }
      .otherCost{
        .total{
          .otherAdd{
            color: rgba(51, 136, 255, 1);
            text-align: right;
            &:hover{
              cursor: pointer;
            }
          }
        }
      }
    }


  }
  ::v-deep{

    .el-dialog__header {
      padding: 9px 20px 9px;
      background: #335483;
    }

    .el-dialog__title {
      line-height: 24px;
      font-size: 14px;
      color: #FFFFFF;
    }

    .el-dialog__headerbtn {
      top: 9px;
    }

    .el-dialog__headerbtn .el-dialog__close {
      color: #fff;
      font-size: 25px;
    }

    .el-dialog__body {
      padding: 0;
      overflow: auto;
      max-height: 75vh;
      color: #606266;
    }

  }

</style>
